var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericMeasureResults',{attrs:{"badge":_vm.badge,"canteen":_vm.canteen,"serviceDiagnostics":_vm.serviceDiagnostics}})}
var staticRenderFns = []

export { render, staticRenderFns }